import React from "react";
import "../styles/SeoLocalSection.css";

function SeoLocalSection() {
  return (
    <section className="seo-local-section">
      <div className="container">
        <div className="seo-local-shell" data-aos="fade-up">
          <div className="seo-local-heading">
            <span>Formacion cerca de ti</span>
            <h2>Cursos profesionales cerca de Ixtapaluca y la Zona Oriente</h2>
          </div>

          <div className="seo-local-grid">
            <article data-aos="fade-up" data-aos-delay="100">
              <strong>Capacitacion local</strong>
              <p>
                Fundacion Nican es una opcion de capacitacion profesional en
                Ixtapaluca para personas que buscan aprender habilidades
                practicas, certificarse y mejorar sus oportunidades laborales en
                Estado de Mexico.
              </p>
            </article>
            <article data-aos="fade-up" data-aos-delay="180">
              <strong>Zona Oriente</strong>
              <p>
                Atendemos alumnos de Ixtapaluca, Chalco, Valle de Chalco y la
                Zona Oriente que quieren estudiar enfermeria, fisioterapia,
                quiropractica, masoterapia, podologia clinica o certificaciones
                SEP-CONOCER.
              </p>
            </article>
            <article data-aos="fade-up" data-aos-delay="260">
              <strong>Empleo y autoempleo</strong>
              <p>
                Si buscas cursos profesionales en Ixtapaluca, certificaciones
                SEP en Ixtapaluca o formacion para emprender en salud y
                bienestar, nuestros programas estan pensados para ayudarte a
                generar ingresos y desarrollarte profesionalmente.
              </p>
            </article>
          </div>
        </div>
      </div>
    </section>
  );
}

export default SeoLocalSection;
